class MojisClubLanding extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.addEventListener('click', event => {
      if (!event.target.closest('[data-club-continue]')) return;
      event.preventDefault();
      this.proceed();
    }, { signal });
    this.addEventListener('change', event => {
      if (!event.target.matches('input[name="club-box"], [data-club-style]')) return;
      if (event.target.matches('input[name="club-box"]')) this.clearPlanError();
      if (event.target.matches('[data-club-style]') && this.categoryOption()) this.clearCategoryError();
      this.querySelector('[data-progression-summary]').hidden = true;
      this.sync();
    }, { signal });
    this.sync();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.errorAnimation?.cancel();
    this.controller = null;
  }
  categoryOption() {
    const option = this.querySelector('[data-club-style]')?.selectedOptions[0];
    return option?.value && !option.disabled ? option : null;
  }
  clearPlanError() {
    this.querySelector('.mclub-plans').setAttribute('aria-invalid', 'false');
    this.querySelector('[data-plan-error]').textContent = '';
  }
  requirePlan() {
    if (this.querySelector('input[name="club-box"]:checked')) {
      this.clearPlanError();
      return true;
    }
    const plans = this.querySelector('.mclub-plans');
    const error = this.querySelector('[data-plan-error]');
    plans.setAttribute('aria-invalid', 'true');
    error.textContent = error.dataset.message;
    plans.scrollIntoView({ block: 'center' });
    plans.querySelector('input').focus({ preventScroll: true });
    return false;
  }
  proceed() {
    const summary = this.querySelector('[data-progression-summary]');
    summary.hidden = true;
    if (!this.requirePlan() || !this.requireCategory()) return false;
    this.sync();
    this.querySelector('[data-progression-result]').textContent = this.querySelector('[data-preview-notice]').textContent.trim();
    summary.hidden = false;
    summary.focus({ preventScroll: true });
    summary.scrollIntoView({ block: 'nearest' });
    return true;
  }
  clearCategoryError() {
    this.querySelector('[data-club-style]')?.setAttribute('aria-invalid', 'false');
    const error = this.querySelector('[data-category-error]');
    if (error) error.textContent = '';
    this.errorAnimation?.cancel();
  }
  requireCategory() {
    if (this.categoryOption()) {
      this.clearCategoryError();
      return true;
    }
    const select = this.querySelector('[data-club-style]');
    const error = this.querySelector('[data-category-error]');
    if (!select) return false;
    select.setAttribute('aria-invalid', 'true');
    if (error) error.textContent = error.dataset.message;
    select.focus({ preventScroll: true });
    const bounds = select.getBoundingClientRect();
    if (bounds.top < 0 || bounds.bottom > window.innerHeight) select.scrollIntoView({ block: 'center' });
    this.errorAnimation?.cancel();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.errorAnimation = select.animate([
        { transform: 'translateX(0)' }, { transform: 'translateX(-3px)' },
        { transform: 'translateX(3px)' }, { transform: 'translateX(0)' }
      ], { duration: 260, iterations: 1 });
    }
    return false;
  }
  sync() {
    const option = this.categoryOption();
    const input = this.querySelector('input[name="club-box"]:checked');
    const plan = input?.closest('[data-club-plan]');
    if (option) this.dataset.style = option.value;
    else delete this.dataset.style;
    this.dataset.categoryValid = String(Boolean(option));
    if (input) this.dataset.selectedPlan = input.value;
    else delete this.dataset.selectedPlan;
    this.querySelectorAll('[data-club-plan]').forEach(card => card.classList.toggle('is-selected', card === plan));
    this.querySelector('[data-style-description]').textContent = option?.dataset.description || '';
    this.querySelector('[data-summary-box]').textContent = plan?.dataset.name || this.querySelector('.mclub-plans legend').textContent.trim();
    const category = this.querySelector('[data-summary-category]');
    category.textContent = option?.textContent.trim() || this.querySelector('[data-club-style] option').textContent.trim();
    category.classList.toggle('is-placeholder', !option);
    this.querySelector('[data-summary-details]').hidden = !plan || !option;
    this.querySelector('[data-summary-placeholder]').hidden = Boolean(plan && option);
    this.querySelector('[data-summary-quantity]').textContent = plan?.querySelector('.mclub-plan__quantity').textContent.trim() || '';
    this.querySelector('[data-summary-recurring]').textContent = plan?.querySelector('[data-monthly-price]').textContent.trim() || '';
  }
}
if (!customElements.get('mojis-club-landing')) customElements.define('mojis-club-landing', MojisClubLanding);
